<template>
  <div id="page-user-view" class="grid xl:grid-cols-3  gap-4 px-4">
    <shipblu-card :cardLoading="merchantInsuranceHistoryLoading" v-if="merchantInsuranceHistory.length > 0" class="xl:col-span-1  mt-4 p-5">
      <page-header :title="$t('Coverage History')" class="mb-4">
      </page-header>
      <div v-for="(item, index) in merchantInsuranceHistory" :key="index" class="md:ml-4">
        <div class="rounded-lg">
          <ul class="vx-timeline w-full mb-0 xs:mb-12 sm:mb-0">
            <li>
              <div class="timeline-icon h-2 w-2 inline-block rounded-full mr-2 bg-grey"></div>
              <div class="flex flex-col">
                <div class="xs:mb-1">
                  <small class="activity-e-status">{{$t("Date")}}</small>
                  <p class="font-medium lg:text-sm">{{ new Date(item.created).toLocaleDateString('fr-CA') }} {{ new Date(item.created).toLocaleTimeString() }}</p>
                </div>
                <div class="flex flex-wrap gap-2 justify-between">
                  <div class="xs:mb-1">
                    <small class="activity-e-status">{{$t("Insurance Package Name")}}</small>
                    <p class="font-medium lg:text-sm">{{item.insurance_package ? item.insurance_package.name + ` (${item.insurance_package.payout_coverage}% ${$t(' payout coverage')})` : '' }}</p>
                  </div>
                  <div class="xs:mb-1">
                    <small class="activity-e-status">{{$t("Effective Date")}}</small>
                    <p class="font-medium lg:text-sm">{{ item.effective_date ? item.effective_date : '' }}</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </shipblu-card>
    <shipblu-card class="mt-4 p-5 xl:col-span-2">
      <fees-on-delivery :merchant="merchant"/>
    </shipblu-card>
  </div>
</template>
<script>
import {sendRequest} from '../../../http/axios/requestHelper.js'
import ShipbluCard from '../../../layouts/components/ShipbluCard.vue'
import FeesOnDelivery from '../../merchant/FeesOnDelivery.vue'

export default {
  data () {
    return {
      merchant: {},
      merchantInsurance: {
        insurance_package: {}
      },
      merchantInsuranceHistory: [],
      merchantInsuranceHistoryLoading: false
    }
  },
  methods: {
    MerchantInsuranceHistory () {
      this.merchantInsuranceHistoryLoading = true
      sendRequest(true, false, this, `api/v1/tracking/merchants/${this.$route.params.merchantID}/insurance-packages/`, 'get', null, true,
        (response) => {
          this.merchantInsuranceHistory = response.data.results
          this.merchantInsuranceHistoryLoading = false
        }        
      )
    },
    loadInsurancePlans () {
      sendRequest(false, false, this, `api/v1/merchants/${this.$route.params.merchantID}/insurance-packages/`, 'get', null, true,
        (response) => { 
          this.merchantInsurance = response.data
        }        
      )
    },
    loadMerchantData () {
      sendRequest(false, false, this, `api/v1/merchants/${this.$route.params.merchantID}/`, 'get', null, true,
        (response) => {
          this.merchant = response.data
        }
      )
    }
  },
  components: {
    ShipbluCard,
    FeesOnDelivery
  },
  created () {
    this.loadInsurancePlans()
    this.loadMerchantData()
    this.MerchantInsuranceHistory()
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";

.vx-timeline {
  margin-left: 0.5rem;
  padding-left: 40px;
  border-left: 2px dotted #e5e8eb;
}
li {
  position: relative;
  .timeline-icon {
    position: absolute;
    top: 0;
    left: -3.2rem !important;
    border-radius: 50%;
    padding: 0px;
    padding: 0.3rem !important;
    padding-bottom: 0.4rem;
  }
}
.title {
  color:#3169fc;
  background-color: transparent !important;
}
.insurance-card{
  border: #D6D6D6 1px solid;
  width:298px;
  border-radius: 9px;
}
.active-insurance {
  border: #3169fc 1px solid;
  width:915px;
  border-radius: 9px;
}
</style>
